import React, { PureComponent } from 'react';
import {
    Typography,
    Paper
} from '@material-ui/core'

const classes = {
    title: {
        fontSize: '0.95rem',
        marginBottom: '0.5rem',
        fontWeight: '500',
    }
}

const nameMap = {
    foodDeserts: 'Food Desert',
    transportation: 'Transportation',
    transit: 'Transit',
    affordableUnits: 'Loss of Affordable Units',
    risingRents: 'Rising Rents',
    race: 'Race',
    income: 'Income',
}

const mapping = {
    'food': 'Food desert',
    'transit': 'Within 0.5 miles of a high volume bus or transit station',
}

class Legend extends PureComponent {
    render() {
        const {
            content,
            layerName,
        } = this.props

        // console.log(content)

        const body = content.map((item, i) => {
            let labels = '';

            switch (layerName) {
                case 'income':
                    labels = `${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.value.min)} to ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.value.max)}`;
                    break;
                case 'affordableUnits':
                    labels = `${(item.value.min).toFixed(0)} to ${(item.value.max).toFixed(0)}`;
                    break;
                default: // transportation, rising rent, race
                    labels = `${new Intl.NumberFormat('en-US', { style: 'percent' }).format(item.value.min)} to ${new Intl.NumberFormat('en-US', { style: 'percent' }).format(item.value.max)}`;
            }

            return (
                <div key={i} className="d-flex align-items-center legend-item">
                    <span style={{ backgroundColor: item.color }}></span>
                    <Typography variant="body2" style={{ maxWidth: 220 }}>
                        {
                            item.value === 'food' || item.value === 'transit'
                                ? mapping[item.value]
                                : labels
                        }
                    </Typography>
                </div>
            )
        })

        return (
            <Paper className="legend" elevation={1}>
                <Typography style={classes.title} variant="h6">{nameMap[layerName]}</Typography>
                {body}
            </Paper>
        )
    }
}

export default Legend